import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import Courseprof from '../Components/Courseprof/Courseprof'
import { Helmet } from 'react-helmet-async'

const Courseforprof = () => {
  return (
    <div>
      <Helmet>
                  <title>VLSI Courses for Working Professionals Online | Takshila VLSI</title>
                  <meta name="description" content="Discover advanced VLSI courses for working professionals to upskill in Physical Design, DFT, Verification, and Analog Layout Design with Takshila VLSI." />
                  <link rel="canonical" href="https://www.takshila-vlsi.com/product-category/vlsi-courses-for-professionals/" />
      
                  <meta property="og:locale" content="en_IN" />
                  <meta property="og:type" content="website" />
                  <meta property="og:site_name" content="Takshila VLSI" />
                  <meta property="og:title" content="VLSI Courses for Working Professionals Online | Takshila VLSI" />
                  <meta property="og:description" content="Discover advanced VLSI courses for working professionals to upskill in Physical Design, DFT, Verification, and Analog Layout Design with Takshila VLSI." />
                  <meta property="og:url" content="https://www.takshila-vlsi.com/product-category/vlsi-courses-for-professionals/" />
                  <meta property="og:image" content="https://www.takshila-vlsi.com/og-image.jpg" />
                  <meta property="og:image:alt" content="Takshila VLSI training programs" />
      
                  <meta name="twitter:card" content="summary_large_image" />
                  <meta name="twitter:title" content="VLSI Courses for Working Professionals Online | Takshila VLSI" />
                  <meta name="twitter:description" content="Discover advanced VLSI courses for working professionals to upskill in Physical Design, DFT, Verification, and Analog Layout Design with Takshila VLSI." />
                  <meta name="twitter:image" content="https://www.takshila-vlsi.com/og-image.jpg" />
      
                  <meta property="article:modified_time" content="2024-12-16T07:02:16+00:00"/>
      
      
              </Helmet>
        <Header/>
        <main>
            <section className='section-banner pg-banner mb-5 p-lg-5 pt-4'>
                    <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md">
                              <div class="pg-title-sec p-lg-5 p-4 bg-3 dark-bg">
                                    <h1 className='pg-title pb-3'>VLSI Courses for Working Professionals</h1>
                                    <p className='pg-title-desc mb-lg-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.
                                    </p>
                                </div>
                              </div>
                          </div>
                    </div>
            </section> 
            <section className='course-list bg-14'>
              <div class="container text-center">
                  <div class="row align-items-start">
                    <div class="col-lg">
                    <Courseprof/>
                    </div>
                  </div>
                </div>
            </section>
        </main> 
        <Enrollaction/>
        <Partnersec/> 
        <Footer/> 
    </div>
  )
}

export default Courseforprof